import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ViewersService } from '../../../../services/viewers.service';
import { ConnectionService } from '../../../../services/connection.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vr-button',
  imports: [CommonModule],
  templateUrl: './vr-button.component.html',
  styleUrl: './vr-button.component.css'
})
export class VrButtonComponent implements OnInit, OnDestroy{
  @Input() isCloseButton: boolean;
  private subscriptions: Subscription[] = [];
  public isFullscreen: boolean = false;

  constructor( 
    private viewersService: ViewersService,
  ){
    this.isCloseButton = false
  }

  ngOnInit(): void {
    // Get fullscreen status
    this.checkFullscreen();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  public onVr() {
    this.viewersService.viewer3d.vr.toggleVR();
  }

  private checkFullscreen() {
    const fullscreen3dEnabled = this.viewersService.viewer3d
      .getObservable('fullscreen_enabled')
      .subscribe((err) => {
        // console.log('3D Viewer Fullscreen Enabled', err);
        this.isFullscreen = true;
      });

    const fullscreen3dDisabled = this.viewersService.viewer3d
      .getObservable('fullscreen_disabled')
      .subscribe((err) => {
        // console.log('3D Viewer Fullscreen Disabled', err);
        this.isFullscreen = false;
      });

    // Subscriptions
    this.subscriptions.push(fullscreen3dEnabled, fullscreen3dDisabled);
  }
  
}
